import { render } from "./glccy.vue?vue&type=template&id=c6734770&scoped=true&ts=true"
import script from "./glccy.vue?vue&type=script&lang=ts"
export * from "./glccy.vue?vue&type=script&lang=ts"

import "./glccy.vue?vue&type=style&index=0&id=c6734770&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6734770"]])

export default __exports__